var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-info",class:_vm.btnClass,attrs:{"disabled":_vm.poster.submitted},on:{"click":function($event){return _vm.posterPost()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }